'use strict';

import EmptyRouterView from '../../app/views/EmptyRouterView.vue';

export const userRoutes = [
  {
    path: '/upload',
    name: 'upload',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/UploadView.vue'),
  },
  {
    path: '/users',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'user.list',
        component: () => import('../views/UserListView.vue'),
      },
      {
        path: 'add',
        name: 'user.add',
        component: () => import('../views/UserAddView.vue'),
      },
      {
        path: ':userId',
        component: EmptyRouterView,
        children: [
          {
            path: '',
            name: 'user.detail',
            props: true,
            meta: {
              requiresAuth: true,
            },
            component: () => import('../views/UserDetailView.vue'),
          },
          {
            path: 'edit',
            name: 'user.edit',
            props: true,
            meta: {
              requiresAuth: true,
            },
            component: () => import('../views/UserEditView.vue'),
          },
        ],
      },
    ],
  },
];
